import {useState, useEffect} from 'react'
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAvatar from "components/MDAvatar"
import { timeConverter } from "timeConverter/timeConverter";

import {getPhotoSource} from "api/requests"
import {readStream} from "readStream/readStream"

import { useTokenContext } from 'App';

import logoMobitoken from "assets/images/mobitoken.png";

function Transaction({ transaction, index}) {

  const [myStorage, setMyStorage] = useState({})
  const {token} = useTokenContext();
  const [nrPhotosDownloaded, setNrPhotosDownloaded] = useState(0)

  useEffect(() => {
    if(transaction){
      let avatarPhoto = ""
      let logoPhoto = ""
      if(transaction['transaction']["sender_type"] === "AVATAR"){
        avatarPhoto = transaction['sender']['photo_id']
        logoPhoto = transaction['receiver']['logo_id']
      } else {
        avatarPhoto = transaction['receiver']['photo_id']
        if(transaction['transaction']['sender_type'] === "SHOP"){
          logoPhoto = transaction['sender']['logo_id']
        }
      }
        if(localStorage.getItem(avatarPhoto) === null){
          getPhotoSource(avatarPhoto, token)
          .then(response => {
            const reader = response.body.getReader();
            readStream(reader)
            .then(base64Response => {
              localStorage.setItem(avatarPhoto, base64Response)
              setNrPhotosDownloaded(nr => nr+1)
            })
            
          })
        }
        if(logoPhoto && localStorage.getItem(avatarPhoto) === null){
          getPhotoSource(logoPhoto, token)
          .then(response => {
            const reader = response.body.getReader();
            readStream(reader)
            .then(base64Response => {
              localStorage.setItem(logoPhoto, base64Response)
              setNrPhotosDownloaded(nr => nr+1)
            })
          })
        }
    }
  }, [transaction]);

  useEffect(() => {
    setMyStorage(localStorage)
  }, [nrPhotosDownloaded])

  function getSenderType(transaction){
    return transaction['transaction']['sender_type'];
  }

  function getReceiverType(transaction){
    return transaction['transaction']['receiver_type'];
  }

  function getSenderName(transaction){
    let senderType = getSenderType(transaction)
    if(senderType === "PLATFORM"){
      return "KASHAF"
    }
    if(senderType === "AVATAR"){
      return transaction['sender']['nickname']
    }
    if(senderType === "SHOP"){
      return transaction['sender']['shop_name']
    }
  }


  function getReceiverName(transaction){
    let receiverType = getReceiverType(transaction)
    if(receiverType === "AVATAR"){
      return transaction['receiver']['nickname']
    }
    if(receiverType === "SHOP"){
      return transaction['receiver']['shop_name']
    }
  }

  function getSenderReceiverPhoto(type){
    //type = sender/receiver
    if(transaction['transaction'][type+"_type"] === "PLATFORM"){
      return logoMobitoken;
    }
    if(transaction['transaction'][type+"_type"]  === "SHOP"){
      return 'data:image/png;base64,' + myStorage[transaction[type]['logo_id']]
    }
    if(transaction['transaction'][type+"_type"]  === "AVATAR"){
      return 'data:image/png;base64,' + myStorage[transaction[type]['photo_id']]
    }
    return null
  }

  function formatType(type){
    const lowercaseType =  type.toLowerCase().replace(/_/g, " ")
    return lowercaseType.charAt(0).toUpperCase() + lowercaseType.slice(1)
}

  function getBackgroundColor(){
    if(index%2 === 0){
      return "#f8f9fa";
    }
    return 'white'
  }

  return (
    <MDBox key={transaction['transaction']['id']} component="li" py={2} px={2} mb={1} sx={{backgroundColor: getBackgroundColor()}}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox display="flex" alignItems="center" sx={{width:"25%" }}>
          <MDBox mr={2}>
            <MDButton variant="outlined" iconOnly circular>
              <MDAvatar src={getSenderReceiverPhoto('sender')} />
            </MDButton>
          </MDBox>
          <MDBox display="flex" flexDirection="column">
            <MDTypography display="block" variant="button" fontWeight="medium" gutterBottom>
              {getSenderName(transaction)}
              {getSenderType(transaction) === "SHOP" &&
                <MDTypography display="block" variant="caption" color="text" fontWeight="regular" gutterBottom fontSize="0.6rem">
                  {transaction['sender']['shop_address']}
                </MDTypography>
              }
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" justifyContent="left" sx={{width:"23%"}}>
          <MDBox mr={2} justifyContent="left">
            <MDButton variant="outlined" iconOnly circular>
            <MDAvatar src={getSenderReceiverPhoto('receiver')} />
            </MDButton>
          </MDBox>
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="button" fontWeight="medium" gutterBottom>
              {getReceiverName(transaction)}
              {getReceiverType(transaction) === "SHOP" &&
                <MDTypography display="block" variant="caption" color="text" fontWeight="regular" gutterBottom fontSize="0.6rem">
                  {transaction['receiver']['shop_address']}
                </MDTypography>
              }
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center" justifyContent="center" sx={{width:"23%"}}>
          <MDTypography variant="button" fontWeight="medium" color="text" gutterBottom > 
              {formatType(transaction['transaction']['type'])}
          </MDTypography>
        </MDBox>
        <MDTypography variant="button" color={"dark"} fontWeight="medium" textGradient sx={{width:"10%"}}>
          {transaction['transaction']['amount'] + " MOBITZ"}
        </MDTypography>
        <MDBox display="flex" alignItems="center" justifyContent="center" sx={{width:"5%"}}>
        {transaction['transaction']['type'] !== "DISCOUNT_CHARGE" ?
          <MDButton variant="outlined" color={"error"} iconOnly circular>
              <Icon sx={{ fontWeight: "bold" }}>expand_more</Icon>
          </MDButton>
        :
          <MDButton variant="outlined" color={"success"} iconOnly circular>
              <Icon sx={{ fontWeight: "bold" }}>expand_less</Icon>
          </MDButton>
        }
        </MDBox>
        <MDTypography variant="caption" fontWeight="regular" color="text" gutterBottom  sx={{width:"10%"}}>
            {timeConverter(transaction['transaction']['created_at'])}
        </MDTypography>
        
      </MDBox>
    </MDBox>
  );
}


export default Transaction;
